import client from './client';

export const billingApi = {
  // GET /billing/overview — the signed-in customer's real subscription,
  // usage, and the current package catalog priced in their billing
  // currency. Backs the "Billing & Plans" page.
  overview: () => client.get('/billing/overview').then((r) => r.data),
  // POST /billing/start-trial — the payment page right after signup. Takes a
  // Stripe PaymentMethod id (created in the browser by Stripe.js) and the
  // chosen plan; opens the 14-day trial. Returns { message, user }.
  startTrial: (payload) => client.post('/billing/start-trial', payload).then((r) => r.data),
  // POST /billing/change-plan — self-serve switch on a Stripe-run
  // subscription (prorated; during the trial nothing is charged and the trial
  // end is kept). Returns { message, subscription, user }.
  changePlan: (packageSlug) =>
    client.post('/billing/change-plan', { package_slug: packageSlug }).then((r) => r.data),
};

export default billingApi;
